import { en } from './en';
import { sv } from './sv';
import { no } from './no';
// Import more languages as needed

export { en, sv, no };

export const languageList = ["en", "sv", "no"];

export const phrasesList = {en, sv, no}